import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "../lib/api";

export default function JournalPage() {
    const [posts, setPosts] = useState(null);

    useEffect(() => {
        api.get("/blog/posts").then((r) => setPosts(r.data)).catch(() => setPosts([]));
    }, []);

    return (
        <div className="bg-brand-paper" data-testid="journal-page">
            <section className="mx-auto max-w-7xl px-6 lg:px-10 pt-20 lg:pt-28 pb-12">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <div className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-5">
                        — The Journal
                    </div>
                    <h1 className="font-serif text-5xl lg:text-7xl leading-[1.05] tracking-tight text-brand-ink">
                        Field notes on <span className="italic">buying & selling</span>
                    </h1>
                    <p className="mt-8 text-lg text-brand-muted max-w-2xl leading-relaxed">
                        Practical, opinionated articles on what actually matters when you
                        choose a realtor and run a transaction.
                    </p>
                </motion.div>
            </section>

            <section className="mx-auto max-w-7xl px-6 lg:px-10 pb-24 lg:pb-32">
                {posts === null && (
                    <div className="text-brand-muted text-sm" data-testid="journal-loading">
                        Loading articles…
                    </div>
                )}
                {posts && posts.length === 0 && (
                    <div className="text-brand-muted text-sm" data-testid="journal-empty">
                        No articles published yet.
                    </div>
                )}
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-brand-line border border-brand-line">
                    {(posts || []).map((post, i) => (
                        <motion.article
                            key={post.id}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.5, delay: i * 0.08 }}
                            className="bg-brand-paper group"
                            data-testid={`journal-card-${post.slug}`}
                        >
                            <Link to={`/journal/${post.slug}`} className="block">
                                {post.cover_image && (
                                    <div className="image-zoom h-56 overflow-hidden">
                                        <img
                                            src={post.cover_image}
                                            alt={post.title}
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                )}
                                <div className="p-8">
                                    <div className="text-xs uppercase tracking-[0.2em] text-brand-gold font-semibold mb-4">
                                        {new Date(post.created_at).toLocaleDateString("en-CA", {
                                            year: "numeric",
                                            month: "long",
                                            day: "numeric",
                                        })}
                                    </div>
                                    <h2 className="font-serif text-2xl lg:text-3xl text-brand-ink leading-tight mb-3 group-hover:text-black">
                                        {post.title}
                                    </h2>
                                    <p className="text-brand-muted leading-relaxed">
                                        {post.excerpt}
                                    </p>
                                    <div className="mt-6 text-sm tracking-wide text-brand-ink inline-flex items-center gap-2 transition-all group-hover:gap-3">
                                        Read article <span aria-hidden>→</span>
                                    </div>
                                </div>
                            </Link>
                        </motion.article>
                    ))}
                </div>
            </section>
        </div>
    );
}
